import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare'
import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'
import { DataHubEntities } from '@space-core/datahub/hotmartClub'
import DataHubService from '@space-core/datahub/hotmartClub/dataHubService'
import useTranslation from '@space-core/hooks/useTranslation'
import { ViewAccessEventSchema } from '@space-shell/modules/mentorship/datahub/schemas/view/viewAccessEventSchema'
import clsx from 'clsx'

import { ArrivedFrom } from '../../types'

export type AccessButtonProps = {
  isSessionInProgress: boolean
  link: string
}

const AccessButton = ({ isSessionInProgress, link }: AccessButtonProps) => {
  const { t } = useTranslation()

  const arrivedFrom = ArrivedFrom.HotmartClubHome

  const redirectToSession = () => {
    const schema = new ViewAccessEventSchema({
      arrivedFrom
    })

    DataHubService.sendEvent({ schema, entity: DataHubEntities.ProductConsume })

    window.open(link, '_blank')
  }

  return (
    <Button
      onClick={redirectToSession}
      variation={isSessionInProgress ? 'primary' : 'secondary'}
      className='_d-flex _align-items-center _mr-md-4'>
      <span className='_mr-3'>{t('general.access')}</span>
      <Icon
        icon={faArrowUpRightFromSquare}
        className={clsx('_text-2', {
          '_text-gray-100': isSessionInProgress,
          '_text-gray-900': !isSessionInProgress
        })}
      />
    </Button>
  )
}

export default AccessButton
